export function IconWarning(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 41.583 38.38"
            {...props}
        >
            <path d="M18.08 1.589l-17.7 32.3a3.038 3.038 0 002.708 4.491h35.411a3.045 3.045 0 002.709-4.488L23.497 1.589a3.1 3.1 0 00-5.417 0zm4.468 13.4l-.36 12.193h-2.8l-.363-12.19zm-1.759 18.83a1.84 1.84 0 111.909-1.839 1.857 1.857 0 01-1.909 1.842z" />
        </svg>
    );
}
